var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 37,
    viewBox: "0 0 46 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2979 0.667922L34.1488 0.5H33.9241H12.0758H11.8511L11.702 0.667924L1.6262 12.0096L1.3262 12.3473L1.63179 12.6799L22.6318 35.5392L23 35.94L23.3682 35.5392L44.3682 12.6799L44.6738 12.3473L44.3738 12.0096L34.2979 0.667922ZM29.2469 10.8483H16.893L14.2154 2.96439H31.976L29.2469 10.8483ZM17.73 13.3127H28.3939L23.0111 28.8629L17.73 13.3127ZM14.2904 10.8483H5.95431L11.9849 4.06002L14.2904 10.8483ZM5.55951 13.3127H15.1273L20.739 29.8362L5.55951 13.3127ZM25.2948 29.7994L31.0017 13.3127H40.4405L25.2948 29.7994ZM40.0457 10.8483H31.8547L34.1514 4.21349L40.0457 10.8483Z",
    fill: "#203468",
    stroke: "#203468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellence);
export default __webpack_public_path__ + "static/media/Excellence.1fc755582e794efbe879d05794a70a60.svg";
export { ForwardRef as ReactComponent };